// on survey validation problem scroll directly to the first element with a problem
// noinspection JSUnusedGlobalSymbols
export default function  (){
    $(window).on('load', function () {
        const $problematicElement = $('.sl-js-has-problem:first');
        if ($problematicElement.length) {
            // subtract the navigation bar height
            let scrollTop = $problematicElement.offset().top - $('nav.navbar').height();
            const $parentSlider = $problematicElement.parents('.sl-js-slider');
            if ($parentSlider.length) {
                // if the problem happens for a slider input subtract also the height of the fixed slider option container
                scrollTop -= $('.sl-floating-header', $parentSlider).height();
            }
            $('html, body').animate({scrollTop: scrollTop}, 1000);
        }
    });
}